'use client';

import { event } from '@/lib/analytics/gtag';
import { t } from '@/lib';
import { LocalizedLink } from '@ui/primitives';

interface ContributeCtaProps {
    locale: string;
    dictionary: Record<string, string>;
    /** Where the block is shown, reported with the click so the placements can be compared. */
    source: 'tablature' | 'profile';
}

export function ContributeCta({ locale, dictionary, source }: ContributeCtaProps) {
    const track = (target: 'studio' | 'contribute') =>
        event({ action: 'contribute_cta_click', category: 'engagement', label: source, target });

    return (
        <section className="my-8 rounded-xl border border-secondary-200 bg-secondary-50 p-6" aria-labelledby={`contribute-cta-${source}`}>
            <h2 id={`contribute-cta-${source}`} className="text-xl font-semibold text-gray-900 mb-2">
                {t(dictionary, 'onboarding.contribute_title')}
            </h2>
            <p className="text-gray-700 mb-4">
                {t(dictionary, 'onboarding.contribute_description')}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
                <LocalizedLink
                    locale={locale}
                    href="/tablatures/studio"
                    variant="primary"
                    className="inline-flex items-center justify-center gap-2 px-4 py-2"
                    onClick={() => track('studio')}
                >
                    <i className="fa-solid fa-plus" />
                    {t(dictionary, 'onboarding.contribute_action')}
                </LocalizedLink>
                <LocalizedLink
                    locale={locale}
                    href="/contribute"
                    variant="secondary"
                    className="inline-flex items-center justify-center gap-2 px-4 py-2"
                    onClick={() => track('contribute')}
                >
                    {t(dictionary, 'onboarding.contribute_more')}
                </LocalizedLink>
            </div>
        </section>
    );
}
